import { render, staticRenderFns } from "./role.vue?vue&type=template&id=301734ec&scoped=true&"
import script from "./role.vue?vue&type=script&lang=ts&"
export * from "./role.vue?vue&type=script&lang=ts&"
import style0 from "./role.vue?vue&type=style&index=0&id=301734ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301734ec",
  null
  
)

export default component.exports